<template>
<div class="pt-3 px-3 pb-1">

        <p v-if="transactions.length == 0" class="text-center">No transactions</p>

        <table v-else class="datatables-basic table">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Transaction</th>
                  <th class="first-right">Balance</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(transaction, index) in transactions" :key="index.id">
              
    <td class="pl-3">
        <div v-if="transaction.project_id">
          <a class="transaction" :href="'/projects/view/'+transaction.project_id+'/0'">
          <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>
          {{transaction.type.name}}<span v-if="transaction.fee_percent"> {{transaction.fee_percent}}%</span></a></div>
        <div v-else>{{transaction.type.name}} <span v-if="transaction.fee_percent">{{transaction.fee_percent}}%</span></div>
        <div :class="transaction.type.action">{{formattedPrice(transaction.amount)}}</div>
        <div class="project_list_date"><small><timeago
                  :datetime="transaction.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(transaction.created_at)"></timeago></small></div>
      </td>
      <td class="font-weight-bold"><span v-if="transaction.payment_type_id !=1 && transaction.balance">{{formattedPrice(transaction.balance)}}</span></td>

            </tr>
          </tbody>
        </table>

    </div>
</template> 

<script>
export default {

  props: ['user'],

  data() {
    return {
      transactions: [],
      loading: false,
    };
  },

  created() {
    this.getTransactions();

    Echo.private("transactions_" + this.user.id)
      .listen("NewTransaction", (event) => {
        this.getTransactions();
      });
      
  },

  methods: {

    getTransactions() {

      this.loading = true;

      axios.get('/transactions/get/' + this.user.id).
      then((response) => {
        this.transactions = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
a.transaction {
  color: #212121;
  text-decoration: none;
  background-color: transparent;
  font-weight: 400 !important;
}
a.transaction:hover {
  color: #212121;
  text-decoration: none;
  background-color: transparent;
  font-weight: 500 !important;
}

</style>